import React, { useState, useContext, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import UserContext from './user.jsx';

import api_json from '../api/json.js';

import { CircularProgress } from '@mui/material';

const JSONContext = React.createContext();

function JSONProvider({ children }) {
	const [json, json_set] = useState(undefined);
	const { session } = useContext(UserContext);
	const { app_uid } = useParams();

	const store = {
		get json() {
			return json;
		},
		set_json: async (data) => {
			await api_json.save({ data, session, app_uid });
			json_set(data);
		},
		get_home() {
			return json?.home;
		},
		set_home: async (home) => {
			await store.set_json({ ...json, home});
		},
		get_eras() {
			return json.eras || [];
		},
		set_eras: async (eras) => {
			await store.set_json({ ...json, eras });
		},
	};

	useEffect(() => {
		if(!app_uid || !session) return;
		(async () => {
			json_set(await api_json.get({ session, app_uid }));
		})();
	}, [app_uid, session]);

	return <JSONContext.Provider value={store}>{children}</JSONContext.Provider>;
}

function JSONDeffer({ children }) {
	const context = useContext(JSONContext);
	const { app_uid } = useParams();

	if (!app_uid) return <CircularProgress size={100} sx={{ mx: 'auto', mt: 20, display: 'block' }} />;

	if (!context.json) return <CircularProgress size={100} sx={{ mx: 'auto', mt: 20, display: 'block' }} />;

	return children;
}

export default JSONContext;
export { JSONProvider, JSONDeffer };
